import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

  static targets = ["CloseModal"]
  connect() {
    this.showModal();
    this.addModalEventListener();
  }

  showModal() {
    const modal = new bootstrap.Modal(this.element);
    modal.show();
  }

  addModalEventListener() {
    $(this.element).on('hidden.bs.modal', this.handleModalHidden.bind(this));
  }

  handleModalHidden(event) {
    const url = `/walkthroughs/${this.element.dataset['slug']}/mark_as_viewed`;
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({}),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': Rails.csrfToken()
      }
    }).then(() => {
      this.element.innerHTML = '';
    });
  }
}
